import { useState } from 'react'
import { ListingParcelData } from '~/components'
import { Button, Dialog } from '~/components/ui'
import { Listing } from '~/models'
import { cn } from '~/utils'

export default function ParcelDataDialog({
  className,
  listing,
}: {
  className?: string
  listing: Listing
}) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <Dialog.Trigger asChild>
        <Button
          className={cn(className, 'text-base print:hidden', 'h-auto p-0')}
          size="sm"
          variant="link">
          View Parcel Data
        </Button>
      </Dialog.Trigger>
      <Dialog.Content className="max-w-xl">
        <Dialog.Header className="mb-2">
          <Dialog.Title>Parcel Data</Dialog.Title>
          <Dialog.Description className="sr-only">
            View listing parcel data
          </Dialog.Description>
        </Dialog.Header>
        <div className="max-h-[80dvh] overflow-y-auto">
          {isOpen && <ListingParcelData listing={listing} />}
        </div>
      </Dialog.Content>
    </Dialog>
  )
}
